export default {"src":"/_next/static/media/saved.e3320322.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};